export default "__VITE_ASSET__oJZw7yBh__"